import { Col, Input, Row } from "reactstrap"
import styles from "./BannerSetting.module.scss"
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton"
import UploadMedia from "../../../../../components/common/UploadMedia/UploadMedia"
import { useState } from "react"

const BannerSetting = () => {
  const [pictures, setPictures] = useState([])

  return (
    <div>
      <div className={styles["heading"]}>Banner Setting</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Headline:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter name of the product" />
            </Col>
          </Row>
          <Row className="g-0">
            <Col xs='12' lg="2">Banner Image:</Col>
            <Col xs='12' lg="4">
              <PrimaryButton name="Upload Images" />
              <div className="d-flex align-items-center">
                <UploadMedia pictures={pictures} setPictures={setPictures} maxMedia={1} allowImages={true} allowVideos={false} />
              </div>
            </Col>
          </Row>

          <Row className="g-0 align-items-center">
            <Col sm='12' lg="2">Destination URL:</Col>
            <Col sm='12' lg="4">
              <Input placeholder="Enter name of the product" type="url" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Call-to-Action:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Shop Now" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default BannerSetting
